import React from 'react';
import PropTypes from 'prop-types';

const HorizontalNavigation = ({
  children,
  onNext,
  onPrevious,
  showNext,
  showPrevious,
}) => (
  <div className='horizontal-navigation'>
    {children}
    {showPrevious && (
      <button
        className='horizontal-navigation__previous'
        onClick={onPrevious}
      />
    )}
    {showNext && (
      <button className='horizontal-navigation__next' onClick={onNext} />
    )}
  </div>
);

HorizontalNavigation.defaultProps = {
  children: null,
  showNext: true,
  showPrevious: true,
};

HorizontalNavigation.propTypes = {
  onNext: PropTypes.func.isRequired,
  onPrevious: PropTypes.func.isRequired,
  showNext: PropTypes.bool,
  showPrevious: PropTypes.bool,
  children: PropTypes.node,
};

export { HorizontalNavigation };
